import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DialogService } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { ParameterSelectionDialogData, TransportOptionParameterSelectionComponent } from '../transport-option-parameter-selection/transport-option-parameter-selection.component';
import { TransportOption, TransportOptionParameter, TransportOptionParameterValue } from '../../transport-options-panel.model';

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TransportOptionParameterComponent),
            multi: true,
        },
    ],
    selector: 'app-transport-option-parameter',
    templateUrl: './transport-option-parameter.component.html',
    styleUrls: ['./transport-option-parameter.component.scss'],
    standalone: false
})
export class TransportOptionParameterComponent implements OnInit, ControlValueAccessor {

  @Input() transportOption: TransportOption;

  @Input() parameter?: TransportOptionParameter;

  selection = new Array<TransportOptionParameterValue>();

  valueString = '';

  constructor(
    public translationService: TranslationService,
    public dialogService: DialogService
  ) { }



  ngOnInit(): void {
  }

  showSelectionDialog() {
    this.dialogService.openDefault(TransportOptionParameterSelectionComponent,
      new ParameterSelectionDialogData({ available: this.parameter?.parameterValues, selected: this.selection }))
      .afterClosed().subscribe(result => {
      console.log('result is', result);
      if (result != null) {
        this.selection = result;
        this.setTextValue();
        this._onChange(this.selection);
      }

    });
  }

  setTextValue() {
    let string = '';
    this.selection.forEach((value, index) => {
      if (index > 0) {
        string += ', ';
      }
      string += this.translationService.translate(value.valueDictionaryKey);
    });
    console.log('concatenated string is', string);
    this.valueString = string;
  }

  public writeValue(value: Array<TransportOptionParameterValue> | null): void {
    if (value != null) {
      this.selection = value;
    } else {
      this.selection = new Array<TransportOptionParameterValue>();
    }
    this.setTextValue();
  }

  private _onChange = (_value: Array<TransportOptionParameterValue> | null): void => undefined;
  public registerOnChange(fn: (value: Array<TransportOptionParameterValue> | null) => void): void {
    this._onChange = fn;
  }

  /** It's called in the component template when we have a "blur" or "input" event */
  public onTouched = (): void => undefined;
  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

}
